export type SubjectType = {
    profile: {
        voterid: string;
        name_eng: string;
        relation_name_eng: string;
        request_level: string;
        gender: string;
        age: number;
        address: string;
        members: number;
        dob: string;
    };

    additional: {
        booth: any;
        family_members_list: Array<object>;
        village: any;
    };

    phone: string;
    whatsapp: string;
    aadharid: string;
    caste: string;

    is_outsider: boolean;
    ac_name: string;
    oacv_name: string;
    oacv_phone: string;

    presence: boolean;
    sameAsPhone?: boolean;
    phoneNotAvailable?: boolean;
};

export type requestType = {
    status: any;
    assignee: any;
    secondary_assignee: any;
    priority: any;
    location: any;
    type: any;
    not_citizen: boolean;
    not_official: boolean;

    more: {
        requested_date: string;
        additional: string;
        attachments: Array<any>;
        ministry: any;
        assembly: any;

        is_fund_required: boolean;
        funds_type: string;
        funds_amount: string;

        is_rtc_required: boolean;
        rtc_details: string;
    };
};

export const defaultRequestValues: requestType = {
    status: {},
    priority: {},
    assignee: {},
    secondary_assignee: {},
    not_citizen: false,
    not_official: false,
    location: {},
    type: {},

    more: {
        requested_date: new Date().toISOString().split("T")[0],
        additional: "",
        attachments: [],
        ministry: null,
        assembly: null,

        is_fund_required: false,
        funds_type: "",
        funds_amount: "",

        is_rtc_required: false,
        rtc_details: "",
    },
};

export const subjectDefaultValues: SubjectType = {
    profile: {
        voterid: "",
        name_eng: "",
        relation_name_eng: "",
        request_level: "Individual",
        gender: "",
        age: 0,
        address: "",
        members: 0,
        dob: "",
    },

    additional: {
        booth: {},
        village: {},
        family_members_list: [],
    },

    presence: false,

    phone: "",
    whatsapp: "",
    aadharid: "",
    caste: "",

    is_outsider: false,
    ac_name: "",
    oacv_name: "",
    oacv_phone: "",

    sameAsPhone: false,
    phoneNotAvailable: false,
};
